export default __webpack_public_path__ + "static/media/Standard05.daa0d486.png";